module.exports = __webpack_public_path__ + "assets/Sign.f6902b2a.svg";